module.exports = __webpack_public_path__ + "static/media/banner3.fa65045c.jpg";